<template>
    <Layout :page="page">
        <div v-html="page.description" />
    </Layout>
</template>

<script setup>
const Layout = defineAsyncComponent(() => import("~/components/Glossary/Layout.vue"));
import {gtm} from '~/composables/gtm.js';


const data = useState('data', () => {});
const error = useState('error');

if (error.value) {
    throw createError(error.value);
}
const page = { ...data.value.page };

gtm.openPage('glossary_item');

definePageMeta({
    middleware: ['page-glossary'],
});
</script>
